export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server)
    return

  // Получаем текущие query-параметры из URL
  const currentQuery = { ...useRoute().query }
  // Если в целевом маршруте не указаны query-параметры
  if (Object.keys(to.query).length === 0 && Object.keys(currentQuery).length > 0) {
    return navigateTo({
      path: to.path,
      query: currentQuery,
    })
  }
})
